// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__38Ts7","calendarButtons":"ClockData_calendarButtons__1bH0i"};